<template>
  <div id="app" class="n-scaleBoxWrap" v-loading="loading">
    <div class="NewHome n-scaleBox" :style="sizeCss">
      <div
        v-if="!isFirst && routeObj && routeObj.path !== '/jhkGuide'"
        class="hookbox"
      ></div>
      <!-- fix:解决bi获取不到全局状态问题 -->
      <!-- 兼容智能BI菜单 -->
      <page-header
        v-show="false"
        height="60px"
        v-if="isLogin && routeObj && routeObj.path.includes('/bi/')"
        :paths="paths"
      ></page-header>
      <!-- padding-top: 60px -->
      <div
        :style="isLogin ? 'height: 100%;' : 'height: 100%;'"
        v-if="
          !nopermission &&
          !isOther &&
          routeObj.path !== '/jhkGuide' &&
          routeObj.path !== '/bi/'
        "
      >
        <!-- 后台管理-帮助中心-使用教程的paths为0，不显示头部 -->
        <!-- <el-header height="60px" v-if="isLogin">
          <page-header :paths="paths" ></page-header>
        </el-header> -->
        <div height="60px" v-if="isLogin">
          <!-- 京获客旗舰版头部 -->
          <page-header-jhk v-if="softType==1" :paths="paths" @itemClick="itemClick" v-show="!isIframe"></page-header-jhk>
          <!-- 云舟头部 -->
          <page-header v-else-if="softType!=1" :paths="paths" @itemClick="itemClick" v-show="!isIframe"></page-header>
        </div>
        <el-container :class="['app-content', {'iframe': isIframe}]">
          <!-- :style="isLogin?'margin-top: 60px;':''" -->
          <el-aside
            v-show="
              isLogin &&
              routeObj.path !== '/peopleFilter' &&
              routeObj.path !== '/miDetal' &&
              routeObj.path !== '/agreement_preview'
            "
            class="aside"
          >
            <left-select @itemClick="itemClick" :style="{ paddingTop: isIframe ? '150px' : '0' }"></left-select>
          </el-aside>

          <el-main class="app-content-main" style="overflow: hidden">
            <!-- <breadpath
              v-show="paths.length > 1 && routeObj.path !== '/platformLogin'"
              :paths="paths"
            ></breadpath> -->
            <top-select :list="topList" :title="firstMenuName" v-if="topList.length" v-show="topList.length > 1" />
            <router-view
              :key="$route.path"
              :class="[
                topList.length == 0 || useMainBox
                  ? 'app-content-main-box'
                  : 'app-content-main-topBox',
              ]"
            ></router-view>
          </el-main>
        </el-container>
      </div>

      <div v-else-if="isOther && routeObj && routeObj.path.includes('/bi/')">
        <page-header-bi
          @biList="getBiList"
          v-if="routeObj.path != '/bi/realTimeData'"
        ></page-header-bi>
        <router-view></router-view>
      </div>
      <div
        v-else-if="
          routeObj &&
          (routeObj.path == '/jhkGuide' || routeObj.path == '/industryPreview')
        "
      >
        <router-view></router-view>
      </div>

      <div v-else-if="isOther && routeObj && routeObj.path !== '/jhkGuide'">
        <page-header-industry></page-header-industry>
        <router-view></router-view>
      </div>

      <div v-else class="have-no-permission">无权限访问</div>
    </div>
  </div>
</template>

<script>
import { login } from "@/api/login";
import { getSellerInfo } from "@/api/sellerController";
import "./utils/test";
import axios from "axios";
// import $ from "jquery";
// import { queryMenu } from "@/api/public";
import Vue from "vue";
import { mapMutations } from "vuex";
import { checkSellerOwnRorNot } from "@/api/public";
import pageHeader from "@/components/page-header"; //总的头部
import pageHeaderJhk from "@/components/page-header_jhk.vue"; //总的头部
import leftSelect from "@/components/left-select"; //总的侧边栏
import topSelect from "@/components/top-select";
import breadpath from "@/components/bread-path"; //总的面包屑
import pageHeaderIndustry from "@/components/page-header-industry"; //总的头部
import pageHeaderBi from "@/components/page-header-BI"; //总的头部
export default {
  components: {
    pageHeader,
    leftSelect,
    topSelect,
    breadpath,
    pageHeaderIndustry,
    pageHeaderBi,
    pageHeaderJhk,
  },
  data() {
    return {
      firstMenuName: '',
      sizeCss: {
        width: "100%",
        height: "100%",
        transform: "",
      },
      paths: [],
      isLogin: false,
      routeVersion1: [],
      routeVersion2: [],
      routeObj: null,
      nopermission: false, // 判断权限
      isOther: false,
      isFirst: false,
      biList: [],
      topList: [],
      useMainBox: true,
      loading: false,
      isIframe: false,
      shopList: [],
    };
  },
  computed: {
    headItem() {
      return this.$store.state.route; //存放在router里边的路径
    },
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    shopTitle() {
      // 店铺名称
      return this.$store.getters.loginUserInfo.shopTitle;
    },
    // softType: 1京获客旗舰版
    softType() {
      if (this.routeObj.path === "/hdHome" || this.$store.getters.loginUserInfo.yunZhouOtherType == '1') {
        return 1;
      } else {
        return '';
      }
    },
    // isOther(){// 是否为另外弹窗（行业专区）
    //   console.log(this.$route,'route')
    //   if(!this.$route.meta.isOther){
    //     return false
    //   }else{
    //     return true
    //   }
    // },
  },
  watch: {
    headItem: {
      deep: true,
      immediate: true,
      handler: function (nval, oval) {
        if (this.routeObj && nval && nval.length > 0) {
          //watch中需要具体执行的方法
          if (this.routeObj.path === "/login") {
            this.isLogin = false;
            return;
          }
          if (
            this.routeObj.path === "/login" ||
            this.routeObj.path === "/redirection" ||
            this.routeObj.path === "/platformLogin" ||
            this.routeObj.path === "/"
          ) {
            this.isLogin = false;
          } else {
            this.isLogin = true;
          }
          var path = location.pathname.replace("/platform", "");

          let route = path.split("/"), //路径里边有/,所以要截取掉
            name = [];
          let index1 = this.headItem.map((i) => i.path).indexOf("/" + route[1]); //取出所对应的索引
          index1 !== -1 &&
            name.push({
              tittle: this.headItem[index1].tittle,
              index: index1,
              path: this.headItem[index1].path,
            });
          if (
            this.headItem[index1] &&
            this.headItem[index1].children &&
            this.headItem[index1].children.length > 0
          ) {
            //第一层数据的判断
            let index2 = this.headItem[index1].children
              .map((i) => i.path)
              .indexOf(route[2]); //取出第二层索引
            index2 !== -1 &&
              name.push({
                tittle: this.headItem[index1].children[index2].tittle,
                index: index2,
                path: this.headItem[index1].children[index2].path,
              });
            if (
              this.headItem[index1].children[index2] &&
              this.headItem[index1].children[index2].children &&
              this.headItem[index1].children[index2].children.length > 0
            ) {
              //子层数据判断
              let index3 = this.headItem[index1].children[index2].children
                .map((i) => i.path)
                .indexOf(route[3]);
              index3 !== -1 &&
                name.push({
                  tittle:
                    this.headItem[index1].children[index2].children[index3]
                      .tittle,
                  index: index3,
                  path: this.headItem[index1].children[index2].children[index3]
                    .path,
                });
            }
          }
          this.paths = name;
          this.$store.state.pathNow = name;
        }
      },
    },
    $route: {
      //监听路由信息对象
      deep: true, //监听的数据深度,一般用来监听对象中某个属性的变化
      immediate: true, //在选项参数中指定true将立即以表达式的当前值触发回调
      handler: function (newval, oldval) {
         this.resize();
        // 无权限判断
        if (newval.path === "/nopermission") {
          this.nopermission = true;
          this.isFirst = true;
          return;
        } else {
          this.nopermission = false;
        }
        this.routeObj = newval;
        //watch中需要具体执行的方法
        console.log("newval.path:", newval.path);
        if (
          newval.path === "/login" ||
          newval.path === "/redirection" ||
          newval.path === "/platformLogin" ||
          newval.path === "/"
        ) {
          this.isLogin = false;
        } else {
          this.isLogin = true;
        }
        if (
          newval.path === "/login" ||
          newval.path === "/redirection" ||
          newval.path === "/platformLogin"
        ) {
          this.isLogin = false;
          this.isFirst = true;
          return;
        }
        if (newval.path === "/") {
          this.isLogin = false;
        }
        if (
          newval.path === "/industryStrategy" ||
          newval.path === "/industrySolution" ||
          newval.path === "/industryCrowd" ||
          newval.path === "/industryPreview" ||
          newval.path.includes("/bi/")
        ) {
          this.isOther = true;
          this.isFirst = true;
        } else {
          this.isOther = false;
        }

        if (newval.path !== "/") {
          this.isFirst = true;
        }
        var path = location.pathname.replace("/platform", "");

        let route = path.split("/"), //路径里边有/,所以要截取掉
          name = [];
        let index1 = this.headItem.map((i) => i.path).indexOf("/" + route[1]); //取出所对应的索引
        index1 !== -1 &&
          name.push({
            tittle: this.headItem[index1].tittle,
            index: index1,
            path: this.headItem[index1].path,
          });
        if (
          this.headItem[index1] &&
          this.headItem[index1].children &&
          this.headItem[index1].children.length > 0
        ) {
          // debugger
          //第一层数据的判断
          let index2 = this.headItem[index1].children
            .map((i) => i.path)
            .indexOf(route[2]); //取出第二层索引
          index2 !== -1 &&
            name.push({
              tittle: this.headItem[index1].children[index2].tittle,
              index: index2,
              path: this.headItem[index1].children[index2].path,
            });
          if (
            this.headItem[index1].children[index2] &&
            this.headItem[index1].children[index2].children &&
            this.headItem[index1].children[index2].children.length > 0
          ) {
            //子层数据判断
            let index3 = this.headItem[index1].children[index2].children
              .map((i) => i.path)
              .indexOf(route[3]);
            index3 !== -1 &&
              name.push({
                tittle:
                  this.headItem[index1].children[index2].children[index3]
                    .tittle,
                index: index3,
                path: this.headItem[index1].children[index2].children[index3]
                  .path,
              });
          }
        }

        this.paths = name;
        this.$store.state.pathNow = name;
      },
    },
    // shopTitle: {
    //   deep: true,
    //   immediate: true,
    //   handler(newVal, oldVal) {
    // console.log('this.shopTitle', this.shopTitle)
    // if (this.shopTitle == '服务市场测试店铺' || this.shopTitle == '初缘旗舰店' || this.shopTitle == '361度逸航专卖店') {
    //   this.$store.state.route = this.routeVersion1;
    // }else {
    //   this.$store.state.route = this.routeVersion2;
    // }
    //   }
    // }
    topList() {
      this.useMainBox = this.topList.some(
        (item) =>
          item.path == "marketing_model" ||
          item.path == "daily_operations" ||
          item.path == "big_promotion_marketing"
      );
    },
  },
  created() {
    sessionStorage.setItem("showNotice", "true");
    sessionStorage.setItem("isPopVisiv", "true");
  },
  mounted: function () {
    const query = Object.fromEntries(new URLSearchParams(window.location.search))
    if(query.isIframe){
      this.isIframe = query.isIframe == "true" ? true : false;
      sessionStorage.setItem("isIframe", this.isIframe);
    }
    if(query.hdToken){
      sessionStorage.setItem("hdToken", query.hdToken);
    }
    window.addEventListener("resize", this.resize);
    this.observeBody();
    Vue.prototype.$checkSellerOwnRorNot = checkSellerOwnRorNot;
    this.$store.state.topPx =
      (document.getElementsByClassName("el-header")[0] &&
        document.getElementsByClassName("el-header")[0].clientHeight) ||
      0;
  },
  methods: {
    observeBody() {
      const observer = new MutationObserver((mutations, observer) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "childList") {
            // 这里可以执行你想要的操作，比如打印新添加的元素
            // 获取所有class为'my-class'的元素
            var elements = document.getElementsByClassName("el-popper");
            // 智能营销气泡提示
            const tooltips = document.getElementsByClassName("tool-tooltip");
            // 遍历这些元素并修改它们的样式
            for (var i = 0; i < elements.length; i++) {
              elements[
                i
              ].style.transform = `scale(${this.$globalData.scaleValue}) `;
              // elements[i].style.top = this.$globalData.scaleValue*elements[i].style.top
            }
            for (var i = 0; i < tooltips.length; i++) {
              tooltips[
                i
              ].style.transform = `scale(${this.$globalData.scaleValue}) `;
              // tooltips[i].style.top = this.$globalData.scaleValue*tooltips[i].style.top
            }
          }
        });
      });
      observer.observe(document.body, {
        childList: true, // 监听目标节点的子节点的变化
        subtree: true, // 监听目标节点下所有节点的变化
      });
    },
    resize() {
      console.log('this.$route.path',this.$route.path);
      
     if(this.$route.path == '/miDetal'){
          this.sizeCss = {
             height: '100%',
             width: '100%',
          };
          return
     }else{
      const w = window.innerWidth;
      const h = window.innerHeight;
      const scale = (w < 1440 ? 1440 : w) / 1920;
      this.sizeCss = {
        transform: `scale(${scale})`,
        height: h / scale + "px",
        width: w / scale + "px",
      };
      this.$globalData.scaleValue = scale;
      this.$globalData.widthValue = w / scale + "px";
      document.body.style.setProperty("--scale", scale);
     }
     
    },
    ...mapMutations({
      editUserInfo: "LOGINUSERINFO",
    }),
    getBiList(list) {
      this.biList = list;
    },
    setCookie(name, value, expire) {
      window.document.cookie =
        name +
        "=" +
        escape(value) +
        (expire == null ? "" : "; expires=" + expire.toGMTString());
    },
    getCookie(Name) {
      var search = Name + "=";
      if (window.document.cookie.length > 0) {
        // if there are any cookies
        let offset = window.document.cookie.indexOf(search);
        if (offset != -1) {
          // if cookie exists
          offset += search.length;
          // set index of beginning of value
          let end = window.document.cookie.indexOf(";", offset);
          // set index of end of cookie value
          if (end == -1) end = window.document.cookie.length;
          return unescape(window.document.cookie.substring(offset, end));
        }
      }
      return null;
    },
    register(name) {
      var today = new Date();
      var expires = new Date();
      // console.log(expires.setTime(today.getTime()));
      expires.setTime(today.getTime() + 1000 * 60 * 60 * 24);
      // expires.setTime(today.getTime() + 1000 * 60 * 5);
      this.setCookie("ItDoor3", name, expires);
    },
    openWin() {
      var c = this.getCookie("ItDoor3");
      if (c != null) {
        sessionStorage.removeItem("visibleXitou");
      } else {
        this.register("xiaolin");
        sessionStorage.setItem("visibleXitou", "true");
      }
    },
    itemClick(list,firstRoute) {
      this.firstMenuName = ""
      this.topList = list;
      // 获取一级菜单名称
      if(firstRoute) {
        this.firstMenuName = firstRoute.tittle
      }
    },
    startLoading() {
      this.loading = true;
    },
    stopLoading() {
      this.loading = false;
    },
  },
  provide() {
    return {
      startLoading: this.startLoading,
      stopLoading: this.stopLoading,
    };
  },
};
</script>

<style lang="scss">
#app {
  transform-origin: top left;
}
.have-no-permission {
  color: #666;
  font-size: 14px;
  padding: 20px;
}
/deep/ .swiper-pagination-bullet-active {
  background-color: #fe4d45 !important;
  width: 8px;
  height: 8px;
}
.el-popover {
  padding: 12px;
}
body {
  margin: 0;
  font-size: 14px;
}
/deep/ .el-cascader__dropdown {
  z-index: 3333 !important;
}
.el-date-picker__time-header .el-date-picker__editor-wrap .el-time-panel {
  left: -48px !important;
}

#app {
  font-family: "Microsoft YaHei", "Arial", "Helvetica", "sans-serif",
    "font_family" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  width: 100%;
}
body {
  background-color: #f5f8fa;
  font-size: 14px;
  margin-left: 0px;
}
#app .el-header {
  padding: 0;
}
#app .aside {
  padding: 0;
  // width: 170px !important;
  width: 210px !important;
  height: 100%;
  // margin-top:-2px;
  // background: #fff;
}
#app .el-main {
  margin: 0;
}
#app /deep/.v-modal {
  z-index: 2888 !important;
}

.el-radio__input.is-checked .el-radio__inner::after {
  transform: translate(-50%, -50%) !important;
}
.el-select__caret.is-reverse {
  transform: rotateZ(180deg) !important;
}
// .el-textarea__inner {
//   border-radius: 0px !important;
// }
.el-message-box__wrapper {
  background: #00000070 !important;
}
.el-drawer__container {
  background: #00000070;
}
.n-scaleBoxWrap {
  width: 100%;
  overflow: hidden;
  height: 100%;
}
.v-modal {
  display: none !important;
}
.n-scaleBox {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 0px !important; /* 设置滚动条的宽度 */
  }
  transform-origin: left top;
}
.el-dialog__wrapper {
  background: #00000070;
}
.el-container {
  padding-bottom: 10px;
}
</style>
<style lang="scss" scoped>
.hookbox {
  position: absolute;
  top: 0;
  height: 70px;
  width: 100%;
  background: #f5f8fa;
  z-index: 999;
}
.NewHome {
  // background:url("./assets/images/newHome/bg1980.png") no-repeat;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-color: #f5f6f9;
  // @media screen and (max-width: 1980px) {
  //   background:url("./assets/images/newHome/bg1980.png") no-repeat;
  // }
}
.app-content {
  height: calc(100% - 80px);
  &.iframe {
    height:100%;
  }
  &-main {
    padding: 0px 12px 0px 15px;
    overflow: hidden;
    &-topBox {
      height: calc(100% - 58px);
      overflow-y: auto;
    }
    &-box {
      height: 100%;
      overflow-y: auto;
    }
  }
}
.app-content-main-box {
  // 隐藏滚动条
  &::-webkit-scrollbar {
    width: 0px;
    background-color: #f5f8fa;
    border-radius: 10px;
    padding: 5px 0;
  }
  &:hover::-webkit-scrollbar {
    width: 0px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #d6d8dd;
    overflow: hidden;
  }
}
/deep/ .el-loading-mask {
  background-color: rgba(255, 255, 255, 0.6); /* 修改背景颜色和透明度 */
}
</style>
